import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles, ArrowRight } from 'lucide-react';
import { API } from '../App';

export default function PlanComparison() {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/plans/public`).then(r => setPlans(r.data?.plans || [])).catch(() => setPlans([]));
  }, []);

  if (!plans.length) return null;

  const ringColors = {
    teal: 'border-teal-500/40',
    amber: 'border-amber-500/60 ring-2 ring-amber-500/20',
    rose: 'border-rose-500/40',
  };
  const accentText = {
    teal: 'text-teal-300',
    amber: 'text-amber-300',
    rose: 'text-rose-300',
  };

  const buyPlan = (planKey) => {
    // Free / starter plan → just send them into the app signup flow
    if (planKey === 'starter' || planKey === 'basic' || planKey === 'free') {
      const REDIRECT_URL = `${window.location.origin}/dashboard`;
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(REDIRECT_URL)}`;
      return;
    }
    // Paid plans → go through public Subscribe page which handles auth + Stripe
    navigate(`/subscribe?plan=${planKey}`);
  };

  return (
    <div className="grid md:grid-cols-3 gap-5">
      {plans.map(p => (
        <div key={p.key} data-testid={`plan-card-${p.key}`} className={`relative rounded-2xl border p-7 bg-[#0f1729]/80 backdrop-blur-sm ${ringColors[p.color] || 'border-slate-700'}`}>
          {p.popular && (
            <div className="absolute -top-3 right-5 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-amber-500 text-black flex items-center gap-1">
              <Sparkles className="w-3 h-3" />Most popular
            </div>
          )}
          <div className={`text-xs uppercase tracking-[0.2em] font-semibold ${accentText[p.color] || 'text-slate-300'}`}>{p.name}</div>
          <h3 className="text-3xl font-bold text-white mt-1">{p.name === 'Enterprise' ? 'Custom' : `AED ${p.price_monthly_aed}`}<span className="text-sm font-normal text-slate-400">{p.name === 'Enterprise' ? '' : '/mo'}</span></h3>
          <p className="text-sm text-slate-400 mt-1">{p.tagline}</p>
          <ul className="mt-5 space-y-2.5">
            {p.features.map((f, i) => (
              <li key={i} className="flex gap-2 text-sm text-slate-300"><CheckCircle className={`w-4 h-4 flex-shrink-0 mt-0.5 ${accentText[p.color] || 'text-slate-400'}`} />{f}</li>
            ))}
          </ul>
          <button
            type="button"
            onClick={() => buyPlan(p.key)}
            data-testid={`plan-cta-${p.key}`}
            className={`mt-6 w-full px-4 py-2.5 rounded-full text-sm font-semibold transition inline-flex items-center justify-center gap-1.5 ${p.popular ? 'bg-amber-500 text-black hover:bg-amber-400' : 'bg-white/10 text-white hover:bg-white/20 border border-white/20'}`}
          >
            {p.key === 'starter' || p.key === 'basic' || p.key === 'free' ? 'Start Free' : p.key === 'enterprise' ? 'Contact Sales' : 'Buy Now'}
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
